import { useTranslations } from '@power-core/toolkit';
import type { FunctionComponent } from 'react';

import { useDate } from '@/modules/utils/custom-hooks/use-date';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import { LoadingIndicator } from '@/ui-components/loading-indicator/loading-indicator';
import { Paragraph } from '@/ui-components/paragraph/paragraph';

import { useSharedDocumentsListInit } from '../../hooks/use-shared-documents-list-init';
import { SharedDocument } from '../shared-document/shared-document';

export const SharedDocumentList: FunctionComponent<{ isOpen?: boolean }> = ({ isOpen }) => {
	const t = useTranslations();
	const { format } = useDate();
	const todayDateStr = format(new Date(), 'YYYY-MM-DD');
	const { documentAccesses, isPending } = useSharedDocumentsListInit({ isProjectOpen: isOpen, todayDateStr });

	if (!isOpen) return null;

	if (isPending) {
		return (
			<Flexbox justify='center' className='mt-5 mb-5'>
				<LoadingIndicator sizing='large' color='primary' />
			</Flexbox>
		);
	}

	if (documentAccesses && documentAccesses.length > 0) {
		return (
			<div className='bg-white dark:bg-card_dark rounded-lg m-1'>
				{documentAccesses.map((documentAccess) => {
					if (!documentAccess.projectDocument) return null;

					return <SharedDocument documentAccess={documentAccess} key={documentAccess.documentId} />;
				})}
			</div>
		);
	}

	return (
		<Flexbox items='center' justify='between' className='p-2'>
			<Paragraph className='text-n500_light_text'>{t('T_NO_SHARING_DOCUMENTS_YET')}</Paragraph>
		</Flexbox>
	);
};
